import { mutatorAction } from 'satcheljs';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export let updateSessionSettings = mutatorAction(
    'updateSessionSettings',
    (defaultFromAddress: string) => {
        getUserConfiguration().SessionSettings.DefaultFromAddress = defaultFromAddress;
    }
);
